export default __webpack_public_path__ + "static/media/app_google.17713a3f.png";